import { ButtonProps } from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import React from 'react';
import { PrimaryButton } from './PrimaryButton';


export type PrintButtonProps = ButtonProps & {
}

export function PrintButton ({children, ...props}: PrintButtonProps) {

    return (
        <PrimaryButton {...props} startIcon={<PrintIcon />}>
            Imprimir
        </PrimaryButton>
    )
}